import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import TourItinerary from '../TourItinerary';
import { SearchStatus } from '../../../../constants';

const TourList = ({ tripId }) => {
  const { responses, status } = useSelector((state) => state.tour);
  const tourList = (responses && responses.travelOptions
    && responses.travelOptions.map((traveloption) => (
      <TourItinerary
        key={traveloption?.itinerary?.uniqueKey}
        tripId={tripId}
        itinerary={traveloption.itinerary}
      />
    )));
  const progressBar = (
    <div className="text-center">
      <CircularProgress color="secondary" />
    </div>
  );
  return (
    <>
      {status === SearchStatus.DONE && tourList}
      {status === SearchStatus.SEARCHING && progressBar }
    </>
  );
};
TourList.propTypes = {
  tripId: PropTypes.string.isRequired,
};

export default TourList;
